export const home = {
  hero: {
    title1: 'Advanced Filtration',
    title2: '& Purification Solutions',
    title3: 'For Industrial Excellence',
    subtitle: 'Comprehensive separation, clarification, and purification technologies designed to optimize your industrial processes and enhance performance across multiple sectors.',
    discoverSolutions: 'Discover Our Solutions',
    requestStudy: 'Request a Study',
    contactUs: 'Contact Us',
    scrollToExplore: 'Scroll to explore',
    imageAlt: 'Advanced Industrial Filtration System',
  },
  overview: {
    whoWeAre: 'Who We Are',
    description: 'specializes in advanced separation and purification technologies, providing comprehensive filtration solutions for diverse industrial applications in Cameroon and Africa.',
    leadingSpecialist: 'Leading Filtration Solutions Specialist',
    weDeliver: 'We deliver cutting-edge purification, clarification, and separation solutions that enhance industrial process performance across multiple sectors.',
    yearsExperience: 'Years Experience',
    industriesServed: 'Industries Served',
    globalPartners: 'Global Partners',
    coreExpertise: 'Core Expertise',
    scientificExpertise: 'Scientific Expertise',
    scientificDescription: 'Advanced research and development in separation technologies',
    processOptimization: 'Process Optimization',
    processDescription: 'Continuous improvement of industrial filtration systems',
    technicalSupport: 'Technical Support',
    supportDescription: '24/7 expert assistance and consultation services',
    qualityAssurance: 'Quality Assurance',
    qualityDescription: 'ISO-certified solutions with guaranteed performance',
    competitiveAdvantages: 'Competitive Advantages',
    continuousInnovation: 'Continuous Innovation & R&D',
    provenReliability: 'Proven Industrial Reliability',
    costOptimization: 'Cost Optimization Solutions',
    customizedEngineering: 'Customized Engineering',
    globalSupply: 'Global Supply Network',
    comprehensiveSupport: 'Comprehensive Technical Support',
    learnMore: 'Learn More About Us',
    advancedTechnologies: 'Advanced Filtration Technologies',
    technologyTypes: 'Reverse Osmosis • Nanofiltration • Ultrafiltration • Microfiltration • Coarse Filtration',
    exploreTechnologies: 'Explore Technologies',
  },
  technologies: {
    title: 'Advanced Filtration Technologies',
    subtitle: 'Comprehensive range of separation and purification technologies tailored to meet diverse industrial requirements',
    scrollLeft: 'Scroll left',
    scrollRight: 'Scroll right',
    viewAll: 'View All Technologies',
    reverseOsmosis: 'Reverse Osmosis',
    roDescription: 'High-pressure membrane filtration for complete purification and desalination of water and industrial fluids.',
    nanofiltration: 'Nanofiltration',
    nfDescription: 'Selective separation of dissolved molecules and multivalent ions for precise industrial applications.',
    ultrafiltration: 'Ultrafiltration',
    ufDescription: 'Membrane-based separation of macromolecules, colloids, and suspended particles from solutions.',
    microfiltration: 'Microfiltration',
    mfDescription: 'Removal of bacteria, suspended solids, and large particles for clarification and sterilization.',
    coarseFiltration: 'Coarse Filtration',
    cfDescription: 'Pre-filtration and removal of large particles to protect downstream equipment and processes.',
    keyApplications: 'Key Applications:',
    waterTreatment: 'Water Treatment',
    desalination: 'Desalination',
    ultraPureWater: 'Ultra-Pure Water',
    waterSoftening: 'Water Softening',
    colorRemoval: 'Color Removal',
    pharmaceutical: 'Pharmaceutical',
    foodBeverage: 'Food & Beverage',
    proteinRecovery: 'Protein Recovery',
    wastewater: 'Wastewater',
    beverageClarification: 'Beverage Clarification',
    sterileFiltration: 'Sterile Filtration',
    cellSeparation: 'Cell Separation',
    pretreatment: 'Pre-treatment',
    sedimentRemoval: 'Sediment Removal',
    equipmentProtection: 'Equipment Protection',
    learnMore: 'Learn More',
  },
  partners: {
    title: 'Our Global Partners',
    subtitle: 'We collaborate with world-leading manufacturers to deliver the highest quality filtration solutions, ensuring performance, reliability, and continuous supply for your industrial needs.',
    qualitySelection: 'Quality Selection Process',
    qualityDescription: 'Every partner is carefully selected based on technological excellence, product quality, global availability, and proven industrial performance. We ensure you receive the best solutions for your specific requirements.',
    exploreAll: 'Explore All Products',
    sagisaDescription: 'Industrial filtration solutions and premium filter media for diverse applications',
    imerysDescription: 'Advanced filtration solutions for food, beverage, and industrial applications',
    filtroxDescription: 'Depth filtration solutions and high-quality filter media for critical processes',
    threeMCTDescription: 'High-performance industrial filtration and separation technologies',
    msDescription: 'Microbiological media production for laboratory and industrial applications',
    filterMedia: 'Filter Media',
    industrialFiltration: 'Industrial Filtration',
    customSolutions: 'Custom Solutions',
    foodBeverage: 'Food & Beverage',
    mineralFiltration: 'Mineral Filtration',
    performanceMaterials: 'Performance Materials',
    depthFiltration: 'Depth Filtration',
    beverageProcessing: 'Beverage Processing',
    membraneTechnology: 'Membrane Technology',
    industrialSolutions: 'Industrial Solutions',
    innovation: 'Innovation',
    cultureMedia: 'Culture Media',
    laboratorySolutions: 'Laboratory Solutions',
    qualityControl: 'Quality Control',
  },
  industries: {
    title: 'Industries We Serve',
    subtitle: 'Delivering specialized filtration and purification solutions across multiple sectors with proven expertise and technical excellence',
    viewAll: 'View All Industries',
    exploreSolutions: 'Explore Solutions',
    foodBeverage: 'Food & Beverage',
    foodBeverageDesc: 'Clarification, sterilization, and purification solutions for food processing and beverage production',
    foodServiceFiltration: 'Food Service Filtration',
    foodServiceDesc: 'Water filtration, beverage quality, and equipment protection solutions for restaurants, cafés, and food service operations',
    pharmaceutical: 'Pharmaceutical & Chemical',
    pharmaDesc: 'Ultra-pure filtration and separation for pharmaceutical manufacturing and chemical processing',
    waterTreatment: 'Water Treatment',
    waterDesc: 'Comprehensive water purification, desalination, and wastewater treatment technologies',
    mining: 'Mining & Metallurgy',
    miningDesc: 'Solid-liquid separation and process water treatment for mining and metal extraction',
    oilGas: 'Oil & Gas',
    oilGasDesc: 'High-performance filtration for upstream, midstream, and downstream operations',
  },
  cta: {
    ready: 'Ready to Optimize Your Industrial Processes?',
    description: 'Our team of filtration experts is ready to analyze your specific requirements and recommend the most effective purification and separation solutions for your operations.',
    requestStudy: 'Request Technical Study',
    response48h: '48-hour response guarantee',
    confidential: 'Confidential consultation',
  },
};